function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBelfastCabTourBalancedView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.982 511.982",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M91.136,88.2c-3.906,4.758-9.843,7.797-16.467,7.797c-6.641,0-12.578-3.047-16.484-7.805L0,287.99 l20.484,5.968l54.17-186.055l54.185,186.071l20.483-5.968L91.136,88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M453.795,88.2c-3.922,4.758-9.844,7.797-16.484,7.797c-6.625,0-12.562-3.047-16.483-7.805 l-58.169,199.797l20.467,5.968l54.186-186.055l54.186,186.071l20.484-5.968L453.795,88.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M74.669,362.643c41.232,0,74.653-33.421,74.653-74.653H0C0,329.222,33.421,362.643,74.669,362.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M437.31,362.643c41.249,0,74.67-33.421,74.67-74.653H362.658 C362.658,329.222,396.078,362.643,437.31,362.643z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BB42"
    },
    d: "M348.378,95.997c-10.453,8.257-174.322,8.257-184.775,0h-31.53 c31.092,32.843,75.106,53.334,123.917,53.334c48.795,0,92.81-20.492,123.916-53.334H348.378z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.78,
    y: 85.331,
    style: {
      fill: "#FFCE54"
    },
    width: 361.53,
    height: 21.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.32,
    y: 10.665,
    style: {
      fill: "#434A54"
    },
    width: 21.343,
    height: 479.97
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5564"
    },
    d: "M255.99,0.001c-17.671,0-31.999,14.328-31.999,31.999v53.333v21.327v63.998 c0,11.789,9.546,21.335,21.327,21.335h21.343c11.781,0,21.328-9.546,21.328-21.335V106.66V85.333V32 C287.989,14.328,273.661,0.001,255.99,0.001z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M74.669,42.663c-17.671,0-31.999,14.328-31.999,31.999c0,17.679,14.328,31.998,31.999,31.998 c17.67,0,31.998-14.319,31.998-31.998C106.667,56.991,92.34,42.663,74.669,42.663z M74.669,85.333 c-5.891,0-10.672-4.789-10.672-10.671c0-5.875,4.781-10.664,10.672-10.664c5.875,0,10.656,4.789,10.656,10.664 C85.325,80.545,80.544,85.333,74.669,85.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M437.31,42.663c-17.671,0-31.998,14.328-31.998,31.999c0,17.679,14.327,31.998,31.998,31.998 c17.672,0,31.999-14.319,31.999-31.998C469.309,56.991,454.982,42.663,437.31,42.663z M437.31,85.333 c-5.875,0-10.656-4.789-10.656-10.671c0-5.875,4.781-10.664,10.656-10.664c5.891,0,10.672,4.789,10.672,10.664 C447.982,80.545,443.201,85.333,437.31,85.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M298.661,383.986c0-23.562-19.109-42.654-42.671-42.654s-42.67,19.093-42.67,42.654l0,0l0,0v85.34 h85.341V383.986L298.661,383.986L298.661,383.986z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M405.312,469.326c0-11.781-9.547-21.343-21.328-21.343H127.995c-11.781,0-21.328,9.562-21.328,21.343 v21.312c0,11.796,9.547,21.343,21.328,21.343h255.989c11.781,0,21.328-9.547,21.328-21.343L405.312,469.326L405.312,469.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M426.654,490.638H85.325c-5.891,0-10.656,4.781-10.656,10.687c0,5.875,4.765,10.656,10.656,10.656 h341.329c5.891,0,10.656-4.781,10.656-10.656C437.31,495.42,432.545,490.638,426.654,490.638z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelfastCabTourBalancedView);
export default __webpack_public_path__ + "static/media/belfast-cab-tour-balanced-view.84949e9b427bd4a777f3c96b3b70bd79.svg";
export { ForwardRef as ReactComponent };